import gql from 'graphql-tag'

export const listLoyaltyCards = gql`
	fragment listLoyaltyCards on LoyaltyCardConnection {
		hasNextPage
		items {
			id
			name
			balance
			points
			type
			isActive
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
		stats {
			points
			balance
			count
		}
		total
	}
`

export const main = gql`
	fragment loyaltyCardMain on LoyaltyCard {
		name
		isActive
		lastUpdatedAt
		isPointsActive
		limit
		dayLimit
		clientName
		clientSurname
		salutation
		additive
		isUser
		userId
		user {
			id
			name
		}
		street
		postcode
		city
		validPhoneNumber
		email
		type
		creditClientId
		creditClient {
			id
			name
		}
		discount {
			freePercent
			masterPercent
			numberOfPercent
		}
		balanceDiscount
		alwaysDiscount
		cashLoad
		balancePoints
		barCode
		statusVirtual {
			type
		}
	}
`

export const immutable = gql`
	fragment immutable on LoyaltyCard {
		accessCode
		balance
		points
		rfid
		virtualCardLink
	}
`
